import { FetchMethod, useCodeerApi } from "../useCodeerApi"
import { Response } from "@/types"

export interface AttachmentsFromContextObjectsRequest {
  context_object_ids: number[]
  workspace_id: string
}

export interface AttachmentsFromContextObjectsResponse {
  attachment_ids: string[]
  created_count: number
  failed_count: number
  existing_count: number
}

export interface ValidateUrlsRequest {
  urls: string[]
  workspace_id: string
  check_only?: boolean
}

export interface ValidateUrlsResponse {
  url: string
  valid: boolean
  error: string | null
}

export const usePostAttachmentsFromContextObjectsApi = () => {
  return useCodeerApi<
    Response<AttachmentsFromContextObjectsResponse>,
    AttachmentsFromContextObjectsRequest
  >("/retrieval/attachments/from-context-objects", FetchMethod.Post)
}
